import React, { useImperativeHandle, useMemo, useState } from 'react'
import dayjs from 'dayjs'
import { check_disabled } from './utils.disabled'

export interface IDpPickerTypeProps {
  type?: string // string // 类型
  defaultStep?: number // string // 步长，间隔
  totalLength?: number, // 总长，比如月份12，时长12，分秒60
  start?: number // 开始计算的数据
  unit?: string // 单位
}

export interface IDpPickerProps {
  title?: string
  type?: string // type === time || showTime = true，只有时间，默认就是日期
  visible?: boolean
  showTime?: boolean
  disabledTime?: any // 禁止时间
  value?: undefined | string
  placeholder?: string
  pickerProps?: any
  onChange?: (date: string | null) => void
  style?: React.CSSProperties
  bodyStyle?: React.CSSProperties
  customStyles?: React.CSSProperties
  disabled?: boolean
  onRef?: any
  onCancel?: Function
  format?: string // 格式类型
  columns?: [
    {
      label: string,
      value: string | number
    }[]
  ]
  config?: {
    [key: string]: IDpPickerTypeProps
  }
}

export const mappingCode: IDpPickerProps['config'] = {
  'YYYY': {
    type: 'year',
    defaultStep: 1,
    totalLength: 20,
    start: Number(dayjs().format('YYYY')),
    unit: lang['年']
  },
  'MM': {
    type: 'month',
    defaultStep: 1,
    totalLength: 12,
    start: 1,
    unit: lang['月']
  },
  'DD': {
    type: 'day',
    defaultStep: 1,
    totalLength: 30, // 30或者31、28都是自动判断的
    start: 1,
    unit: lang['日']
  },
  'HH': {
    type: 'hour',
    defaultStep: 1,
    totalLength: 24,
    start: 0,
    unit: lang['时']
  },
  'mm': {
    type: 'minute',
    defaultStep: 1,
    totalLength: 60,
    start: 0,
    unit: lang['分']
  },
  'ss': {
    type: 'second',
    defaultStep: 1,
    totalLength: 60,
    start: 0,
    unit: lang['秒']
  }
}

export const formatFunc = (format: string | undefined) => {
  if (!format) return []
  let _list: string[] = []
  const _splitFormat = format?.split(' ')
  for (let i = 0; i < _splitFormat.length; i++) {
    const current = [..._splitFormat[i]?.split('-')]
    const _item = (current?.length > 1) ? current : _splitFormat[i]?.split(':')
    _list = _list.concat(_item)
  }
  return _list
}

// export const columnsFunc = (props: IDpPickerProps, _format: string[], currentSelect: string | null) => {
//   const _list: any[] = []
//   const transformData = (list: string[], currentSelect: string | null) => {
//     const _disabled = props?.disabledTime
//     const _formatType: any = {
//       YYYY: 'YYYY',
//       MM: 'YYYY-MM',
//       DD: 'YYYY-MM-DD',
//       HH: 'YYYY-MM-DD HH',
//       mm: 'YYYY-MM-DD HH:mm',
//       ss: 'YYYY-MM-DD HH:mm:ss',
//     }
    
//     let disabledDate: any  = ''
//     if ((typeof props?.disabledTime !== 'function') && (_disabled?.startDate || _disabled?.endDate)) {
//       disabledDate = {
//         startDate: _disabled?.startDate ? dayjs(_disabled?.startDate)?.format('YYYY-MM-DD HH:mm:ss') : undefined,
//         endDate: _disabled?.endDate ? dayjs(_disabled?.endDate)?.format('YYYY-MM-DD HH:mm:ss') : undefined,
//       }
//     }
//     // 先这样处理，有时间在抽离，disabledTime为function要再加，以及日期的时候
//     for(let i = 0; i < list.length; i++) {
//       let _subList: { label: string | number, value: string }[] = []
//       const current: IDpPickerTypeProps = {
//         ...mappingCode?.[list[i]],
//         ...props?.config?.[list[i]]
//       }
//       if (list[i] === 'DD') { // 月份比较特殊
//         const findIndex = _format?.findIndex(item => item === 'MM')
//         const currentDD = currentSelect?.[findIndex ]
//         let _subListCurrent = []
//         for(let node = 0; node < dayjs(`${currentSelect?.[0]}-${currentDD}-01`).daysInMonth(); node++) {
//           const isVerificationPassed = check_disabled({
//             currentSelect,
//             _format,
//             disabledDate,
//             type: list[i],
//             node,
//             format: _formatType[list[i]],
//             formatType: current?.type
//           })
//           if (!!isVerificationPassed) {
//             let _node: string | number = Number(current.start) + node
//             _subListCurrent.push({ label: _node, value: `${_node}` })
//           }
//         }
//         _subList = _subListCurrent
//       } else if (['YYYY', 'MM']?.includes(list[i])) { // 月份比较特殊
//         let _subListCurrent = []
//         for(let node = 0; node < (current?.totalLength || 12); node++) {
//           const isVerificationPassed = check_disabled({
//             currentSelect,
//             _format,
//             disabledDate,
//             type: list[i],
//             node: Number(current.start) + node,
//             format: _formatType[list[i]],
//             formatType: current?.type
//           })
//           if (!!isVerificationPassed) {
//             let _node: string | number = Number(current.start) + node
//             _subListCurrent.push({ label: _node, value: `${_node}` })
//           }
//         }
//         _subList = _subListCurrent
//       } else {
//         let total = (current?.totalLength || 60) / Number(current?.defaultStep);
//         let _subListCurrent = []
//         for(let node = 0; node < total; node++) {
//           let _node: string | number = Number(current?.defaultStep || 1) * node
//             if (Number(_node) < 10) {
//               _node = `${0}${_node}`
//             }
//           const isVerificationPassed = check_disabled({
//             currentSelect,
//             _format,
//             disabledDate,
//             type: list[i],
//             node: _node,
//             format: _formatType[list[i]]
//           })
//           if (isVerificationPassed) {
//             _subListCurrent.push({ label: _node + `${current.unit}`, value: `${_node}` })
//           }
//         }
//         _subList = _subListCurrent
//       }
//       _list.push(_subList)
//     } 
//   }
//   transformData(_format, currentSelect)
//   return _list
// }

export const transformChangeSubmit = (format: string, _format: string[], value: number[]) => {
  let _value = format
  for (let i = 0; i < _format.length; i++) {
    _value = _value?.replace(_format[i], `${value?.[i]}`)
  }
  return _value
}